import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react';
import { cn } from '@/lib/utils';
import { TableHead } from './table';

export type SortOrder = 'asc' | 'desc' | undefined;

interface SortableTableHeadProps {
  children: React.ReactNode;
  sortKey: string;
  currentSortBy?: string;
  currentSortOrder?: SortOrder;
  onSort: (sortBy: string, sortOrder: SortOrder) => void;
  className?: string;
}

export function SortableTableHead({
  children,
  sortKey,
  currentSortBy,
  currentSortOrder,
  onSort,
  className,
}: SortableTableHeadProps) {
  const isActive = currentSortBy === sortKey;

  const handleClick = () => {
    if (!isActive) {
      // First click - sort descending (most recent first for dates, highest first for numbers)
      onSort(sortKey, 'desc');
    } else if (currentSortOrder === 'desc') {
      // Second click - sort ascending
      onSort(sortKey, 'asc');
    } else {
      // Third click - clear sort
      onSort('', undefined);
    }
  };

  return (
    <TableHead
      className={cn(
        'cursor-pointer select-none hover:bg-muted transition-colors',
        isActive && 'bg-muted',
        className,
      )}
      onClick={handleClick}
    >
      <div className="flex items-center gap-1">
        <span>{children}</span>
        <span className={isActive ? 'text-foreground' : 'text-muted-foreground'}>
          {isActive ? (
            currentSortOrder === 'asc' ? (
              <ArrowUp className="h-4 w-4" />
            ) : (
              <ArrowDown className="h-4 w-4" />
            )
          ) : (
            <ArrowUpDown className="h-4 w-4 opacity-50" />
          )}
        </span>
      </div>
    </TableHead>
  );
}
